(function () {
  if (window.__cardVariantAddInit) return;
  window.__cardVariantAddInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function updateCartBubble() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        var bubble = link.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            link.appendChild(bubble);
          }
          var count = cart.item_count < 100 ? cart.item_count : '';
          bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>';
        }
      })
      .catch(function () {});
  }

  function flash(btn, cls) {
    btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, 1600);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-variant-add');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok || (res.data && res.data.status)) {
          flash(btn, 'is-error');
          return;
        }
        updateCartBubble();
        flash(btn, 'is-done');

        // Si un tiroir panier est présent, on tente de l'ouvrir (sinon, compteur + retour bouton suffisent)
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (err) {}
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        flash(btn, 'is-error');
      });
  });
})();
